// src/App.js
import React from "react";
import "flag-icon-css/css/flag-icons.min.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import BookTablePage from "./pages/BookTablePage";
import PrivateEventsPage from "./pages/PrivateEventsPage";
import OrderPage from "./pages/OrderPage";
import ContactPage from "./pages/ContactPage";
import BuffetBookingPage from "./pages/BuffetBookingPage";
import ThankYouPage from "./pages/ThankYouPage";
import CartModal from "./components/CartModal";
import ScrollToTop from "./components/ScrollToTop";
import { CartProvider } from "./context/CartContext";
import { UserProvider } from "./context/UserContext";
import { CheckoutProvider } from "./context/CheckoutContext";
import CheckoutModalWrapper from "./components/CheckoutModalWrapper";
import { ProfileProvider } from "./context/ProfileContext";

function App() {
  return (
    <UserProvider>
      <ProfileProvider>
        <CartProvider>
          <CheckoutProvider>
            <Router>
              <ScrollToTop />
              <Navbar />
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/book-table" element={<BookTablePage />} />
                <Route path="/private-events" element={<PrivateEventsPage />} />
                <Route path="/order-online" element={<OrderPage />} />
                <Route path="/buffet" element={<BuffetBookingPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/thank-you" element={<ThankYouPage />} />
              </Routes>
              <Footer />
              <CartModal />
              <CheckoutModalWrapper />
            </Router>
          </CheckoutProvider>
        </CartProvider>
      </ProfileProvider>
    </UserProvider>
  );
}

export default App;
